<template>
  <FormMainContainer
    :long-content="true"
    :title="$t('confirm_appointment_page.title')"
    :previous-step-route="previousStepRoute"
  >
    <AppointmentConfirmation @goToSubmissionForm="goToSubmissionForm" />
  </FormMainContainer>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import FormMainContainer from '~concierge/components/FormMainContainer.vue'
import HeaderSection from '~concierge/components/HeaderSection.vue'
import FooterSection from '~concierge/components/FooterSection.vue'
import AppointmentConfirmation from '~concierge/components/AppointmentQuestionComponents/AppointmentConfirmation.vue'
import { router } from '@inertiajs/vue3'

export default defineComponent({
  name: 'ConfirmAppointmentPage',
  components: { HeaderSection, FooterSection, AppointmentConfirmation, FormMainContainer },
  props: {
    previousStepRoute: {
      type: String,
      required: true
    },
    submissionRoute: {
      type: String,
      required: true
    }
  },
  methods: {
    goToSubmissionForm(): void {
      if (this.submissionRoute.length > 0) {
        router.visit(this.submissionRoute)
      }
    }
  }
})
</script>
